import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import RemoveTaskZmkForUserRequest from '../../../projects/task/i-service/models/task-order/request/RemoveTaskZmkForUserRequest';
import AddTaskZmkForUserRequest from '../../../projects/task/i-service/models/task-order/request/AddTaskZmkForUserRequest';
import SubscribeToOrderTaskRequest from '../../../projects/task/i-service/models/task-order/request/SubscribeToOrderTaskRequest';
import SubscribeToOrderTaskListRequest from '../../../projects/task/i-service/models/task-order/request/SubscribeToOrderTaskListRequest';
import UnSubscribeToOrderTaskRequest from '../../../projects/task/i-service/models/task-order/request/UnSubscribeToOrderTaskRequest';
import UnSubscribeToOrderTaskListRequest from '../../../projects/task/i-service/models/task-order/request/UnSubscribeToOrderTaskListRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import UpsertTaskOrderForUserEventResponse from '../../../projects/task/i-service/models/task-order/response/UpsertTaskOrderForUserEventResponse';

/**
 * * Сервис сохранения сортировки задач
 */
export default class TaskOrderSaveService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Событие на изменение списка очерёдности задач у пользователя
	 */
	OnUpsertTaskZmkForUserEvent = new Events<WsResponseModelT<UpsertTaskOrderForUserEventResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('TaskOrderSaveService', 'OnUpsertTaskZmkForUser', 'Main', (res: WsResponseModelT<UpsertTaskOrderForUserEventResponse>) => {
			self.OnUpsertTaskZmkForUserEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Удаление задачи змк для пользователя в очередность
	 */
	async RemoveTaskZmkForUser(request: RemoveTaskZmkForUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskOrderSaveService',
			Method: 'RemoveTaskZmkForUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавление задачи для пользователя в очередность
	 */
	async AddTaskZmkForUser(request: AddTaskZmkForUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskOrderSaveService',
			Method: 'AddTaskZmkForUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Подключение к комнате страницы/подстраницы очерёдности задач пользователя
	 */
	async SubscribeToOrderTask(request: SubscribeToOrderTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskOrderSaveService',
			Method: 'SubscribeToOrderTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Подключение к комнате страницы/подстраницы очерёдности задач пользователя
	 */
	async SubscribeToOrderTaskList(request: SubscribeToOrderTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskOrderSaveService',
			Method: 'SubscribeToOrderTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отключение от комнаты страницы/подстраницы очерёдности задач пользователя
	 */
	async UnSubscribeToOrderTask(request: UnSubscribeToOrderTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskOrderSaveService',
			Method: 'UnSubscribeToOrderTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Подключение к комнате страницы/подстраницы очерёдности задач пользователя
	 */
	async UnSubscribeToOrderTaskList(request: UnSubscribeToOrderTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskOrderSaveService',
			Method: 'UnSubscribeToOrderTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Удаление задачи змк для пользователя в очередность
	 */
	async removeTaskZmkForUserAsync(request: RemoveTaskZmkForUserRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskOrderSaveService',
				Method: 'RemoveTaskZmkForUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавление задачи для пользователя в очередность
	 */
	async addTaskZmkForUserAsync(request: AddTaskZmkForUserRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskOrderSaveService',
				Method: 'AddTaskZmkForUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Подключение к комнате страницы/подстраницы очерёдности задач пользователя
	 */
	async subscribeToOrderTaskAsync(request: SubscribeToOrderTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskOrderSaveService',
				Method: 'SubscribeToOrderTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Подключение к комнате страницы/подстраницы очерёдности задач пользователя
	 */
	async subscribeToOrderTaskListAsync(request: SubscribeToOrderTaskListRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskOrderSaveService',
				Method: 'SubscribeToOrderTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отключение от комнаты страницы/подстраницы очерёдности задач пользователя
	 */
	async unSubscribeToOrderTaskAsync(request: UnSubscribeToOrderTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskOrderSaveService',
				Method: 'UnSubscribeToOrderTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Подключение к комнате страницы/подстраницы очерёдности задач пользователя
	 */
	async unSubscribeToOrderTaskListAsync(request: UnSubscribeToOrderTaskListRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskOrderSaveService',
				Method: 'UnSubscribeToOrderTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}